/*sm-pragma-loader:trim-start eslint-disable lodash/prefer-lodash-method*/
import { formatDate } from '../utils/formatDate';
import mainSliderTracking from '../../lib/bind-event-tracking/main-gallery';
import additionalSliderTracking from '../../lib/bind-event-tracking/additional-gallery';
import smAppSubscribe from '../../components/sm-app-subscribe-v1/sm-app-subscribe-v1';
import smFooter from '../../components/sm-footer/sm-footer';
import smComments from '../sm-landing-appstore-app-1-comments/sm-landing-appstore-app-1-comments';
import smRatingCharts from '../sm-landing-appstore-app-1-rating-charts/sm-landing-appstore-app-1-rating-charts';
import smHead, { INSTALL_BTN_CLASS, INSTALL_BTN_CLASS_STICKY } from '../sm-landing-appstore-app-1-head/sm-landing-appstore-app-1-head';
import smGallery from '../sm-landing-appstore-app-1-gallery/sm-landing-appstore-app-1-gallery';
import smInformation from '../sm-landing-appstore-app-1-information/sm-landing-appstore-app-1-information';
import smOffers from '../sm-landing-appstore-app-1-offers/sm-landing-appstore-app-1-offers';
import smPurchases from '../sm-landing-appstore-app-1-purchases/sm-landing-appstore-app-1-purchases';
import smSupports from '../sm-landing-appstore-app-1-supports/sm-landing-appstore-app-1-supports';
import smDeveloperApps from '../sm-landing-appstore-app-1-developer-apps/sm-landing-appstore-app-1-developer-apps';
import smShortDescription from '../sm-landing-appstore-app-1-short-description/sm-landing-appstore-app-1-short-description';
import smEditorNotes from '../sm-landing-appstore-app-1-editor-notes/sm-landing-appstore-app-1-editor-notes';
import smIosPanel from '../sm-landing-appstore-app-1-ios-panel/sm-landing-appstore-app-1-ios-panel';
import smWhatsNew from '../sm-landing-appstore-app-1-whats-new';



const mainGalleryTracking = mainSliderTracking();
const additionalGalleryTracking = additionalSliderTracking();



export { INSTALL_BTN_CLASS, INSTALL_BTN_CLASS_STICKY };

export default function ($cmp, { data, featuredBanner, installActionType, isIPAD }) {
  const _date = data.date_updated || data.date_released || '';
  const whatsNewDate = formatDate(_date);

  return `
    <div class="sm-landing-appstore-app-1 ${data.ios_panel ? 'sm-landing-appstore-app-1--had-ios-panel' : ''}">
      <div class="sm-landing-appstore-app-1__layout">
        <div class="sm-landing-appstore-app-1__layout-in sm-featured-page-bg-main">
          ${featuredBanner ? `
            <div class="sm-landing-appstore-app-1__featured">
              <div class="sm-landing-appstore-app-1__featured-img-placeholder"></div>
              <div class="sm-landing-appstore-app-1__featured-img" style="background: url(${featuredBanner.url}) no-repeat center center; background-size: cover;"></div>
            </div>
          ` : ''}
          ${$cmp('sm-landing-appstore-app-1__head sm-featured-page-bg-main sm-featured-page-border-txt',
    smHead, {
      icon: data.icon,
      name: data.name,
      subheader: data.subheader,
      installUrl: data.install_url,
      features: data.features,
      price: data.price,
      currency: data.currency,
      inAppPurchases: data.in_app_purchases,
      rating: data.rating,
      reviews: data.reviews,
      contentRating: data.content_rating,
      storePosition: data.store_position,
      category: data.category,
      stickyHeader: data.sticky_header,
      vendor: data.vendor,
      installActionType,
      featuredBanner,
      editorsChoiceText: data.editors_choice_text
    })}
          <div class="sm-landing-appstore-app-1__content">
            ${data.in_app_purchases_feature && data.in_app_purchases_list && data.in_app_purchases_list.length && !isIPAD ? `
              <div class="sm-landing-appstore-app-1__separator"></div>
              <div class="sm-landing-appstore-app-1__section">
                ${$cmp('sm-landing-appstore-app-1__in-app-purchases', smPurchases, { inApps: data.in_app_purchases_list, isFeature: true })}
              </div>
              <div class="sm-landing-appstore-app-1__separator"></div>
            ` : ''}

            ${(data.screenshots.length || data.videos.length) ? `
              <!--<div class="sm-landing-appstore-app-1__screenshots-title">Preview</div>-->
              <div class="sm-landing-appstore-app-1__screenshots">
                ${$cmp('sm-landing-appstore-app-1__gallery', smGallery, {
    galleryTracking: mainGalleryTracking,
    screenshots: data.screenshots,
    videos: data.videos
  })}
              </div>

            ` : ''}

            <div class="sm-landing-appstore-app-1__offers-wr">
              ${$cmp('sm-landing-appstore-app-1__offers', smOffers, {
    galleryTracking: mainGalleryTracking,
    offersAppleWatch: data.offers_apple_watch,
    offersAppleTV: data.offers_apple_tv,
    offersImessage: data.offers_imessage,
    offersIpad: data.offers_ipad,
    appleWatch: data.apple_watch,
    appleTv: data.apple_tv,
    isIPAD
  })}
            </div>
            <div class="sm-landing-appstore-app-1__separator"></div>

            ${data.promo_text ? `
              <div class="sm-landing-appstore-app-1__section-promo-wr">
                <div class="sm-landing-appstore-app-1__section-promo">${data.promo_text}</div>
                <div class="sm-landing-appstore-app-1__separator"></div>
              </div>
            ` : ''}

            ${data.description ? `
              <div class="sm-landing-appstore-app-1__section">
                ${$cmp('sm-landing-appstore-app-1__short-description', smShortDescription, {
    vendor: data.vendor,
    description: data.description
  })}
              </div>
              <div class="sm-landing-appstore-app-1__separator"></div>
            ` : ''}


            ${(data.additionalVideos.length > 0) ? `
              <div class="sm-landing-appstore-app-1__screenshots-title">${__('sm@_a_closer_look')}</div>
              <div class="sm-landing-appstore-app-1__screenshots">
                ${$cmp('sm-landing-appstore-app-1__gallery', smGallery, {
    galleryTracking: additionalGalleryTracking,
    screenshots: null,
    videos: data.additionalVideos
  })}
              </div>
              <div class="sm-landing-appstore-app-1__separator"></div>
            ` : ''}

            <div class="sm-landing-appstore-app-1__section">
              <div class="sm-landing-appstore-app-1__section-in sm-landing-appstore-app-1__section-in--ratings-reviews">
                <div class="sm-landing-appstore-app-1__section-h">
                  <div class="sm-landing-appstore-app-1__section-h-main">${__('sm@_ratings_reviews')}</div>
                </div>
                <div class="sm-landing-appstore-app-1__section-content">
                  ${$cmp('sm-landing-appstore-app-1__section-rating', smRatingCharts, {
    rating: data.rating,
    rating_5: data.rating_5,
    rating_4: data.rating_4,
    rating_3: data.rating_3,
    rating_2: data.rating_2,
    rating_1: data.rating_1,
    reviews: data.reviews
  })}

                  ${data.comments && data.comments.length ? $cmp('sm-landing-appstore-app-1__section-comments', smComments, { comments: data.comments }) : ''}
                  <!-- TODO: NEED ADD EDITOR_NOTES TO DATA! -->
                  ${data.editor_notes ? $cmp('m-landing-appstore-app-1__section-editor-notes', smEditorNotes, {
    text: data.editor_notes
  }) : ''}
                </div>
              </div>
            </div>
            <div class="sm-landing-appstore-app-1__separator"></div>



            ${data.release_notes ? `
              <div class="sm-landing-appstore-app-1__section">
                <div class="sm-landing-appstore-app-1__section-in sm-landing-appstore-app-1__section-in--whats-new">
                  ${$cmp('sm-landing-appstore-app-1__whats-new', smWhatsNew, {
    date: whatsNewDate,
    version: data.software_version,
    text: data.release_notes
  })}
                </div>
              </div>
              <div class="sm-landing-appstore-app-1__separator"></div>
            ` : ''}

              ${!data.in_app_purchases_feature && data.in_app_purchases_list && data.in_app_purchases_list.length ? `
                <div class="sm-landing-appstore-app-1__section">
                  <div class="sm-landing-appstore-app-1__section-in sm-landing-appstore-app-1__section-in--purchases">
                    ${$cmp('sm-landing-appstore-app-1__in-app-purchases', smPurchases, { inApps: data.in_app_purchases_list })}
                  </div>
                </div>
                <div class="sm-landing-appstore-app-1__separator"></div>
              ` : ''}

            <div class="sm-landing-appstore-app-1__section sm-landing-appstore-app-1__section--information">
              <div class="sm-landing-appstore-app-1__section-in sm-landing-appstore-app-1__section-in--information">
                ${$cmp('sm-landing-appstore-app-1__information', smInformation, {
    seller: data.seller,
    content_rating: data.content_rating,
    file_size: data.file_size,
    operating_systems: data.operating_systems,
    languages: data.languages,
    apple_watch: data.offers_apple_watch && data.apple_watch,
    category: data.category,
    in_app_purchases: data.in_app_purchases,
    license_agreement: data.license_agreement,
    privacy_policy: data.privacy_policy,
    developer_website: data.developer_website,
    isIPAD
  })}
              </div>
            </div>

            ${data.supports ? `
              <div class="sm-landing-appstore-app-1__separator"></div>
              <div class="sm-landing-appstore-app-1__section">
                ${$cmp('sm-landing-appstore-app-1__section-supports', smSupports, {
    supports: data.supports
  })}
              </div>
            ` : ''}


            ${data.developer_apps ? `
              <div class="sm-landing-appstore-app-1__section sm-landing-appstore-app-1__section--developer-apps">
                <div class="sm-landing-appstore-app-1__section-in sm-landing-appstore-app-1__section-in--developer-apps">
                  ${$cmp('sm-landing-appstore-app-1__section-developer-apps', smDeveloperApps, {
    apps: data.developer_apps,
    developer: data.vendor
  })}
                </div>
              </div>
            ` : ''}

            ${$cmp('sm-landing-appstore-app-1__footer', smFooter)}
          </div>
        </div>
      </div>
    </div>


    ${$cmp('sm-landing-appstore-app-1__app-subscribe', smAppSubscribe, {
    installActionType,
    installActionPopup: data.install_action_popup || {},
    owner: data.vendor
  })}

    ${data.ios_panel ? $cmp('sm-landing-appstore-app-1__ios-panel', smIosPanel) : ''}

  </div>
  `;
}



// WEBPACK FOOTER //
// ./src/landing-appstore-app-1/sm-landing-appstore-app-1/sm-landing-appstore-app-1.template.js